import { Theme } from "@mui/material";

const getStyles = (theme: Theme) => ({
  fullheight: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
    width: "100%",
  },
  innerBox: { p: 2 },
  titleBox: { height: 24, display: "flex", alignItems: "center" },
  title: { fontSize: theme.fontSizes.sm, textTransform: "uppercase", mr: 1 },
  valueText: { fontSize: theme.fontSizes.display },
  insightText: { fontWeight: theme.typography.fontWeightLight, fontSize: theme.fontSizes.sm },
  iconBox: {
    borderRadius: theme.radius.full,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.background.paper,
    height: 18,
    width: 18,
    fontSize: theme.fontSizes.md,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mr: 1,
  },
  icon: {
    color: theme.palette.background.paper,
  },
});

export default getStyles;
